import { render } from "./VinList.vue?vue&type=template&id=f8127e42&scoped=true"
import script from "./VinList.vue?vue&type=script&lang=js"
export * from "./VinList.vue?vue&type=script&lang=js"

import "./VinList.vue?vue&type=style&index=0&id=f8127e42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8127e42"]])

export default __exports__